import {Fragment, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {notification} from "antd";
import ActionBar from "~/layout/ActionBar";
import {
	Loading, Icon, Button, Modal
} from "~/components";
import {
	apiError,
	handleRequest,
	strToTime
} from "~/utils";
import {
	receiptActions,
	receiptErrorSelector,
	receiptFilterSelector,
	receiptItemsSelector,
	receiptLoadingSelector,
	receiptPaginationSelector
} from "../receiptSlice";
import {
	receiptGroupActions,
	receiptGroupItemsSelector
} from "../receiptGroupSlice";
import {
	ReceiptTable,
	ReceiptFormAddEdit,
	ReceiptSearchBar
} from "../components";
import {
	receiptApi
} from "~/api";

function Receipt() {

	const dispatch   = useDispatch();

	const items      = useSelector(receiptItemsSelector);

	const loading    = useSelector(receiptLoadingSelector);

	const error      = useSelector(receiptErrorSelector);

	const pagination = useSelector(receiptPaginationSelector);

	const filter     = useSelector(receiptFilterSelector);

	const [itemEdit, setItemEdit] = useState({});

	const [categories, setCategories] = useState({});

	const listGroup = useSelector(receiptGroupItemsSelector);

	const [openModal, setOpenModal] = useState({
		addEdit: false,
		delete: false,
	});

	const handleModalOpen = (modal) => {
		openModal[modal] = true;
		setOpenModal({...openModal})
	}

	const handleModalClose = (modal) => {
		openModal[modal] = false;
		setOpenModal({...openModal});
	}

	const handleLoadCategories = async () => {
		let [error, response] = await handleRequest(receiptApi.groupGets());
		let message = apiError(`Lấy loại phiếu thu thất bại`, error, response);
		if(!message) {
			setCategories(response.data);
		}
	}

	useEffect(() => {
		handleLoadCategories();
		dispatch(receiptGroupActions.fetchData({}))
	}, []);

	useEffect(() => {
		dispatch(receiptActions.fetchData({
			...filter,
		}));
	}, [filter]);

	if (error) {
		notification.error({message: 'Lỗi', description: error});
	}

	const handleSaveItem = async (data, isEdit) => {
		let messageAction = 'Thêm mới';
		if(isEdit) {
			if (!itemEdit?.id) {
				notification.error({message: 'Lỗi', description: 'Không có thông tin phiếu thu để cập nhật'});
				return;
			}
			data.id = itemEdit.id;
			messageAction = 'Cập nhật';
		}
		data.time = strToTime(data.time);
		let [error, response] = (isEdit) ? await handleRequest(receiptApi.update(data)) : await handleRequest(receiptApi.add(data));
		let message = apiError(`${messageAction} phiếu thu thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `${messageAction} phiếu thu thành công`});
			if(!isEdit) {
				const added = Array.isArray(response.data) ? response.data : [response.data];
				added.forEach(item => dispatch(receiptActions.add(item)));
			}
			else {
				setItemEdit(response.data);
				dispatch(receiptActions.update(response.data));
			}
			handleModalClose('addEdit')
		}
	}

	const handleDelete = async () => {
		if (!itemEdit?.id) {
			notification.error({message: 'Lỗi', description: 'Không có thông tin phiếu thu để xóa'});
			return;
		}
		let [error, response] = await handleRequest(receiptApi.delete(itemEdit.id));
		let message = apiError(`Xóa phiếu thu thất bại`, error, response);
		if(!message) {
			notification.success({message: 'Thành công', description: `Xóa phiếu thu thành công`});
			dispatch(receiptActions.delete(itemEdit.id));
			handleModalClose('delete')
		}
	}

	const handlePaginationChange = (page) => {
		dispatch(receiptActions.setFilter({...filter, page}));
	}

	const handleFilterChange = (key, value) => {
		const newFilter = {
			...filter,
			[key]: value,
			page: 1
		};
		dispatch(receiptActions.setFilter(newFilter));
	};

	return (
		<Fragment>
			<ActionBar title={'Phiếu thu'}>
				<Button outline leftIcon={Icon.plusCircle} onClick={() => {setItemEdit({}); handleModalOpen('addEdit')}}>Thêm mới</Button>
				<Button background green to="/receipt">Phiếu thu</Button>
				<Button outline green to="/receipt/group">Loại phiếu thu</Button>
				<Button outline small onClick={() => dispatch(receiptActions.fetchData({...filter}))} style={{fontSize:'20px'}}>{Icon.reload}</Button>
			</ActionBar>
			<div className="container">
				<div className="content">
					{loading && <Loading/>}
					{<ReceiptSearchBar filter={filter} categories={categories} onChange={handleFilterChange} />}
					{items && <ReceiptTable
						items={items}
						pagination={pagination}
						onPaginationChange={handlePaginationChange}
						setItemEdit={setItemEdit}
						openModal={handleModalOpen}
					/>}
				</div>
				{
					<Modal title="Phiếu Thu" visible={openModal.addEdit} onCancel={() => {handleModalClose('addEdit')}}>
						<ReceiptFormAddEdit item={itemEdit} listGroup={listGroup} onHandleSubmit={handleSaveItem} />
					</Modal>
				}
				{
					(itemEdit?.id) && <Modal title="Xóa phiếu thu" visible={openModal.delete} onCancel={() => {handleModalClose('delete')}}>
						<p>Bạn muốn xóa phiếu thu <b>PT{itemEdit?.id}</b>?</p>
						<br />
						<div className="d-flex justify-content-end gap pd-1 modal-bottom">
							<Button white leftIcon={Icon.close} onClick={() => {handleModalClose('delete')}}> Đóng </Button>
							<Button primary leftIcon={Icon.delete} onClick={handleDelete}> Xóa </Button>
						</div>
					</Modal>
				}
			</div>
		</Fragment>
	)
}

export default Receipt;

